import React, {useState} from 'react'
import {LabeledAutocomplete, LabeledInput, LabeledSelect} from "@/Components/Form";
import {BASE_SCOPES} from "@/Enums/scopes";
import {Inertia} from "@inertiajs/inertia";

export function EmmaLightActivityItem({
  factors,
  errors,
  activity = false,
  setAccordionHeading
}) {

  const errorBagKey = activity ? 'updateManagedActivity.' + activity.id : false;

  const [dirty, setDirty] = useState(false);
  const [activityRequest, setActivityRequest] = useState({
    name: activity.name || '',
    question: activity.question || '',
    scope: activity.scope || null,
    emission_factor_id: activity.emission_factor_id || null,
    tag: activity.tag || null,
  });

  const BASE_TAGS = ['Transport', 'Product usage', 'Energy'];

  function handleFormUpdate(e) {
    setDirty(true);
    const new_req = { ...activityRequest };
    new_req[e.target.name] = e.target.value;
    setActivityRequest(new_req);
  }

  function handleUpdateActivity() {
    if(activity.id !== undefined) {
      Inertia.put(`/admin/managed-activities/${activity.id}`, activityRequest, {
        onSuccess: () => {
          setAccordionHeading(activityRequest.name);
          setDirty(false);
        }
      });

      return;
    }

    Inertia.post(`/admin/managed-activities`, activityRequest, {
      onSuccess: () => {
        setDirty(false);
        setActivityRequest(prevValues => ({...prevValues, name: '', question: ''}));
      }
    });
  }

  function SaveButton() {
    let disabled = false

    if (!dirty) {
      disabled = true
    }

    return <button
      disabled={disabled}
      onClick={handleUpdateActivity}
      className="self-end ml-3 btn"
    >
      Save changes
    </button>
  }

  return (
    <>
      <LabeledInput
        name="name"
        title="Heading"
        placeholder="Name the activity"
        className="mb-4"
        value={activityRequest.name}
        onChange={handleFormUpdate}
        error={errors && (errorBagKey ? errors[errorBagKey]?.name : errors.name)}
      />
      <LabeledInput
        name="question"
        title="Question"
        placeholder="Explain what data should be reported"
        className="mb-4"
        value={activityRequest.question}
        onChange={handleFormUpdate}
        error={errors && (errorBagKey ? errors[errorBagKey]?.question : errors.question)}
      />
      <LabeledAutocomplete
        name="emission_factor_id"
        title="Choose emission factor"
        options={factors}
        placeholder="Pick an emission factor"
        className="mb-4"
        defaultValue={activityRequest.emission_factor_id}
        onSelect={handleFormUpdate}
        error={errors && (errorBagKey ? errors[errorBagKey]?.emission_factor_id : errors.emission_factor_id)}
      />
      <LabeledSelect
        name="scope"
        title="Choose scope"
        defaultValue={activityRequest.scope}
        options={BASE_SCOPES}
        className="mb-4"
        onChange={handleFormUpdate}
        error={errors && (errorBagKey ? errors[errorBagKey]?.scope : errors.scope)}
      />

      <LabeledSelect
        name="tag"
        title="Choose tag"
        defaultValue={activityRequest.tag}
        options={BASE_TAGS.map(t => ({value: t, label: t}))}
        className="mb-4"
        onChange={handleFormUpdate}
        error={errors && (errorBagKey ? errors[errorBagKey]?.tag : errors.tag)}
      />

      <div className="flex flex-row justify-end">
          <SaveButton/>
      </div>
    </>
  )
}
